require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./die-rohre-kommen.json") })
        }
      }, "path---die-rohre-kommen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---die-rohre-kommen!./.cache/json/die-rohre-kommen.json
// module id = 419
// module chunks = 231608221292675